<template>
  <div class="section">
    <div class="container">
      <h1>Graph historical data</h1>
      <div class="columns">
        <div class="column is-2">
          <b-field label="Start period">
            <b-select placeholder="Start Period" v-model="selectedPeriods.start">
              <option v-for="opt in periodList" :value="opt" :key="opt">{{opt}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="End period">
            <b-select placeholder="End Period" v-model="selectedPeriods.end">
              <option v-for="opt in periodList" :value="opt" :key="opt">{{opt}}</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <!--<div class="columns is-vcentered">
        <div class="column is-12">
          <b-field label="Filters">
            <filters v-model="filters"></filters>
          </b-field>
        </div>
      </div>-->
      <div>
        <b-button class="is-primary" @click="GetReport()" v-bind:class="{'is-loading': loading}">Get report</b-button>
      </div>
      <br />
      <div class="clear" v-if="scoreData.datasets">
        <score-chart :chart-data="scoreData" show-btn></score-chart>
      </div>
      <div class="columns" v-if="scoreData.datasets">
        <div class="column breathe">
          <b-table :data="ScoreData"
                   :columns="Labels"
                   :loading="loading"
                   paginated
                   :mobile-cards="true"
                   pagination-size="is-small"
                   :pagination-simple="true"
                   per-page="20"
                   :default-sort="SortingLabel"
                   default-sort-direction="desc">
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  //import scoreChart from '@/services/components/ScoreChart.vue';
  import scoreChart from '@/services/components/ScoreChartCountries.vue';
  import filters from '@/services/components/Filters.vue';
  export default {
    components: {
      scoreChart,
      filters
    },
    data: function () {
      return {
        scoreData: {},
        filters: [],
        periodList: [],
        selectedPeriods: {},
        loading: false
      }
    },
    computed: {
      SortingLabel() {
        return this.Labels[this.Labels.length - 1].label;
      },
      Labels() {
        if (!this.scoreData.labels)
          return [];
        else {
          var labels = [];
          var periods = this.scoreData.labels;

          labels.push({ field: "CountryName", label: "Country", width: 300, sortable: true });

          periods.forEach(period => {
            var item = { field: period, label: period, width: 400, sortable: true };
            labels.push(item);
          });

          return labels;
        }
      },
      ScoreData() {
        if (!this.scoreData.labels)
          return [];
        else {
          var list = [];
          var periods = this.scoreData.labels;

          this.scoreData.datasets.forEach(data => {
            var set = { CountryName: data.label };
            for (var i = 0; i < periods.length; i++) {
              set[periods[i]] = data.data[i];
            }
            list.push(set);
          });

          return list;
        }
      }
    },
    methods: {
      GetReport() {
        this.loading = true;
        this.$http.post("api/report/scoring", {
          selectedPeriods: this.selectedPeriods,
          filters: this.filters
        }).then(resp => {
          this.scoreData = resp.data;
          this.loading = false;
        });
      },
      Navigate(id) {
        this.$router.push({ name: 'complianceIndexCountry', params: { countryId: id } });
      }
    },
    async created() {
      await this.$http.get("api/report/periods")
        .then(resp => {
          this.periodList = resp.data;
          this.selectedPeriods.start = this.periodList[0];
          this.selectedPeriods.end = this.periodList[this.periodList.length - 1];
        }).catch(err => {
          console.error(err);
        })

      this.GetReport();
    },
    mounted() {

    }
  }
</script>
